import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDeleteDatabasesParams {
  ids: string[];
}

export class DeleteDatabasesRequest extends Request<IDeleteDatabasesParams, IResult> {
  constructor(params: IDeleteDatabasesParams) {
    super('deleteDatabases', params);
  }
}
